module.exports = __webpack_public_path__ + "fonts/BlenderPro-Medium.2bec13e.woff";